import { render, staticRenderFns } from "./FormFolderDetails.vue?vue&type=template&id=184d3230&"
import script from "./FormFolderDetails.vue?vue&type=script&lang=js&"
export * from "./FormFolderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports